import { projectsAddTagToFilter } from "../redux/actions/projects";
import { scrollToSection } from "./scrollToSection";
export const handleAddTagToFilter = (tagName, dispatch, filterTags) => () => {
  if (filterTags.every((name) => name !== tagName)) {
    dispatch(projectsAddTagToFilter(tagName));
    scrollToSection("projects");
  }
};
